import '../sass/styles.scss';
import Modal from 'bootstrap/js/dist/modal';
import Glide, { Breakpoints, Controls, Swipe, Autoplay } from '@glidejs/glide/dist/glide.modular.esm';

window.jQuery = $;
window.$ = $;

document.addEventListener('DOMContentLoaded', () => {
	if ($('.slider').length) {
		let answers = new Glide('.slider', {
			type: 'carousel',
			autoplay: 5000,
			animationDuration: 350,
			gap: 30,
			perView: 1,
			focusAt: 'center',
			dragThreshold: true,
			breakpoints: {
				992: {
					perView: 1,
				},
			},
		}).mount({
			Controls,
			Breakpoints,
			Swipe,
			Autoplay,
		});
	}

	gformSettings();

	$(document).bind('gform_post_render', function () {
		gformSettings();
	});

	function gformSettings() {
		// Prevent checking checkbox when opening rules modal
		$('.rules-link').click(function (e) {
			e.preventDefault();
		});
	}

	if (typeof dataLayer !== 'undefined' && dataLayer) {
		dataLayer.push({
			pageTitle: '+Kaikki',
			fullCategory: '/kaikki/',
			category: 'pluskaikki',
			pageType: 'Campaign page',
		});
	}

/*
	// Show Sanoma Media CMP
	$('body').on('click', '#cookiesetup', function () {
		utag.link({ event_name: 'cmp_privacy_manager', event_action: 'show' });
	});

	// Init thanks modal
	const thanks = new Modal(document.getElementById('thanks'), {
		keyboard: false,
		backdrop: 'static',
	});

	$(document).on('gform_confirmation_loaded', function (event, formId) {
		// Trigger GA event
		if (typeof dataLayer !== 'undefined' && dataLayer) {
			dataLayer.push({
				event: 'CampaignEvent',
				eventCategory: 'osallistuminen',
				eventAction: 'lomake',
				eventLabel: 'lähetetty',
			});
		}

		$('.form-container').hide();

		thanks.show();

		// Redirect after 5 seconds
		var delay = 5000;
		var url = '';
		setTimeout(function () {
			window.location = url;
		}, delay);
	});

	// Scroll to first error field on validation error
	$(document).on('gform_post_render', function (event, formId) {
		var $form = jQuery('#gform_' + formId);
		var $firstError = $form.find('.gfield_error:first');

		if ($firstError.length) {
			$('html, body').animate(
				{
					scrollTop: $firstError.offset().top - 100,
				},
				800,
			);
		}
	});
 */

});
